import React from 'react';

const ActionButton = ({ onClick, icon, label, variant = 'primary', className = '' }) => {
  const baseClasses = 'px-2 py-1 rounded-lg transition-colors duration-200 text-white';
  const variantClasses = {
    primary: 'bg-blue-500 hover:bg-blue-600',
    danger: 'bg-red-500 hover:bg-red-600',
    warning: 'bg-yellow-500 hover:bg-yellow-600',
    success: 'bg-green-500 hover:bg-green-600'
  };

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      title={label}
    >
      <i className={`fas ${icon}`}></i>
    </button>
  );
};

export default ActionButton; 